var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEngagement({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2904 6.29729H22.7921C22.7921 5.46698 22.1215 4.79785 21.2927 4.79785H12.296C11.4672 4.79785 10.7966 5.46698 10.7966 6.29729H6.29827C5.46945 6.29729 4.79883 6.96642 4.79883 7.79673V10.7956C4.79883 14.1079 7.48432 16.7934 10.7966 16.7934C10.8671 16.7934 10.9327 16.7742 11.0016 16.7713C11.5403 18.8813 13.1878 20.5318 15.2949 21.078V25.79H12.296C11.4672 25.79 10.7966 26.4591 10.7966 27.2894V28.7889H22.7921V27.2894C22.7921 26.4591 22.1215 25.79 21.2927 25.79H18.2938V21.078C20.4009 20.5318 22.0484 18.8817 22.5871 16.7716C22.656 16.7742 22.7216 16.7934 22.7921 16.7934C26.1044 16.7934 28.7899 14.1079 28.7899 10.7956V7.79673C28.7899 6.96642 28.1192 6.29729 27.2904 6.29729ZM7.79771 10.7956V9.29617H10.7966V13.7945C9.14045 13.7945 7.79771 12.4502 7.79771 10.7956ZM25.791 10.7956C25.791 12.4502 24.4482 13.7945 22.7921 13.7945V9.29617H25.791V10.7956Z",
    fill: "#2894D2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEngagement);
export default __webpack_public_path__ + "static/media/engagement.3f67f2921a9d75a678a28ac370fc9caa.svg";
export { ForwardRef as ReactComponent };